export const BlobURlsDetails = {
    extensionMRPUpdateTemplate: 'ExtensionMRPUpdateTemplate',
    requestorAddItems: 'RequestorAddItems',
    changeSARExcelTemplate: 'ChangeSARExcelTemplate',
    extensionMRPUpdateTemplateUserGuide : 'ExtensionMRPUpdateTemplateUserGuide',
    requestorAddItemsUserGuide: 'RequestorAddItemsUserGuide',
    changeSARExcelTemplateUserGuide: 'ChangeSARExcelTemplateUserGuide',
}